import { render, staticRenderFns } from "./PreviewImg.vue?vue&type=template&id=245baa6a&scoped=true"
import script from "./PreviewImg.vue?vue&type=script&lang=js"
export * from "./PreviewImg.vue?vue&type=script&lang=js"
import style0 from "./PreviewImg.vue?vue&type=style&index=0&id=245baa6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245baa6a",
  null
  
)

export default component.exports